import React, { useState } from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import { Box, ListItem, ListItemIcon, ListItemText, Typography } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import BuildIcon from "@material-ui/icons/Build";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import HomeIcon from "@material-ui/icons/Home";
import InfoIcon from "@material-ui/icons/Info";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import LocalParkingIcon from "@material-ui/icons/LocalParking";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import SettingsIcon from "@material-ui/icons/Settings";
import CameraIcon from "@material-ui/icons/CameraAlt";
import NLCLogo from "src/assets/images/logo_sidebar_expanded.png";
import NLCLogoBorder from "src/assets/images/logo_sidebar_border.png";
import NLCLogoDryPort from "src/assets/images/logo_sidebar_dry_port.png";
import NLCLogoOffDock from "src/assets/images/logo_sidebar_off_dock.png";
import NLCLogoHqDashboard from "src/assets/images/logo_sidebar_hq_dashboard.png";
import { AuthRoute } from "src/modules/auth/auth.routes";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    nested: {
      paddingLeft: theme.spacing(7),
    },
    ListItemIcon: {
      minWidth: "40px",
    },
    DEV: { backgroundColor: "#E67817" },
  })
);

export function DynamicDrawerContent() {
  const match = useRouteMatch();
  const classes = useStyles();
  const [expand, setExpand] = useState<string | undefined>(match.path);

  const backendRoutes = JSON.parse(localStorage.getItem("nodUserMenus") as string);
  const terminalType = Number(localStorage.getItem("terminalType"));

  return (
    <div className="drawerContent">
      <div className={classes.toolbar}>
        <Box my={1} textAlign="Center" pt={"10px"}>
          <img
            src={
              terminalType === 0
                ? NLCLogoBorder
                : terminalType === 1
                ? NLCLogoOffDock
                : terminalType === 2
                ? NLCLogoDryPort
                : terminalType === 3
                ? NLCLogoHqDashboard
                : terminalType === 4
                ? NLCLogoDryPort
                : NLCLogo
            }
            alt="logo"
            width="140"
          />
        </Box>
      </div>
      <List>
        {backendRoutes
          .filter((r: any) => r.path !== AuthRoute.path)
          .map((route: any, i: any) => (
            <div className="sideNavItems" key={i}>
              {/* Start Parent Routes */}
              <ListItem
                button
                component={NavLink}
                to={route.routeName}
                activeClassName="Mui-selected slectedTopItem"
                className="TopItem"
                onClick={() => {
                  if (route.childMenus?.length)
                    if (expand === route.routeName) setExpand(undefined);
                    else setExpand(route.routeName);
                }}
              >
                <ListItemIcon className={classes.ListItemIcon}>
                  {route?.icon === "EmojiTransportationIcon" ? (
                    <EmojiTransportationIcon />
                  ) : route?.icon === "LocalShippingIcon" ? (
                    <LocalShippingIcon />
                  ) : route?.icon === "BuildIcon" ? (
                    <BuildIcon />
                  ) : route?.icon === "SettingsIcon" ? (
                    <SettingsIcon />
                  ) : route?.icon === "HomeIcon" ? (
                    <HomeIcon />
                  ) : route?.icon === "LocalOfferIcon" ? (
                    <LocalOfferIcon />
                  ) : route?.icon === "InsertDriveFileIcon" ? (
                    <InsertDriveFileIcon />
                  ) : route?.icon === "LocalParkingIcon" ? (
                    <LocalParkingIcon />
                  ) : route?.icon === "CameraIcon" ? (
                    <CameraIcon />
                  ) : (
                    <InfoIcon />
                  )}
                </ListItemIcon>
                <ListItemText>
                  <Typography variant="subtitle1">{route.title}</Typography>
                </ListItemText>
                {route.childMenus?.length ? (
                  expand === route.routeName ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : (
                  ""
                )}
              </ListItem>
              {/* END Parent Routes */}

              {route.childMenus
                ?.filter((ss: any) => !ss.noDrawer)
                ?.map((sub: any, j: any) => (
                  // SubMenu here
                  <Collapse
                    key={`${i},${j}`}
                    in={expand === route.routeName}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      <ListItem
                        button
                        className={(classes.nested, "notSelectedSubItem")}
                        component={NavLink}
                        to={`${route.routeName}${sub.routeName}`}
                        // Mui-selected
                        activeClassName="slectedSubItem"
                      >
                        <ListItemText>
                          <Typography variant="body2">{sub.title}</Typography>
                        </ListItemText>
                      </ListItem>
                    </List>
                  </Collapse>
                ))}
            </div>
          ))}
      </List>
    </div>
  );
}
